import { createTheme } from '@mui/material'
import robotoRegular from '../assets/Roboto-Regular.ttf'
import robotoLight from '../assets/Roboto-Thin.ttf'
// import UserService from './userService'

class ThemeProvider {
    /**
     * Constructor.
     * @version 1.0.0
     */
    constructor() {
        this.type = 'light'
        this.backendKey = 'vcw_podo-it'
    }

    /**
     * Get voetmax theme
     *
     * @returns {Object} a palette with theme colors
     */
    voetmax() {
        return {
            mode: this.type,
            primary: {
                main: '#0a54bf',
                box: '#0a54bf',
                contrastText: '#fff'
            },
            secondary: {
                main: '#bb33bb',
                box: '#bb33bb',
                contrastText: '#fff'
            },
            tertiary: {
                main: '#7146be',
                box: '#7146be',
                contrastText: '#fff'
            },
            error: {
                main: '#FF4444',
                light: '#FFCFCF'
            },
            success: {
                main: '#23B956',
                light: '#CFFFAA'
            }
        }
    }

    /**
     * Get schutrups theme
     *
     * @returns {Object} a palette with theme colors
     */
    schutrups() {
        return {
            mode: this.type,
            primary: {
                main: '#000000',        // Black (background / text contrast)
                box: '#1A1A1A',         // Slightly lighter black for boxes/cards
                contrastText: '#FFFFFF' // White text on dark background
            },
            secondary: {
                main: '#B22222',        // Deep red (stars, accents, buttons)
                box: '#8B1A1A',         // Darker red for hover/pressed state
                contrastText: '#FFFFFF' // White text on red
            },
            tertiary: {
                main: '#FFFFFF',        // White (headers, clean areas)
                box: '#F5F5F5',         // Light grey/white box background
                contrastText: '#000000' // Black text on white
            },
            error: {
                main: '#FF4444',        // Bright error red
                light: '#FFCFCF'        // Soft pink background
            },
            success: {
                main: '#23B956',        // Bright green for success
                light: '#CFFFAA'        // Soft green background
            }

        }
    }

    /**
     * Get vcw theme
     *
     * @returns {Object} a palette with theme colors
     */
    vcw() {
        return {
            mode: this.type,
            primary: {
                main: '#0a54bf',
                box: '#0a54bf',
                contrastText: '#fff'
            },
            secondary: {
                main: '#bb33bb',
                box: '#bb33bb',
                contrastText: '#fff'
            },
            tertiary: {
                main: '#7146be',
                box: '#7146be',
                contrastText: '#fff'
            },
            error: {
                main: '#FF4444',
                light: '#FFCFCF'
            },
            success: {
                main: '#23B956',
                light: '#CFFFAA'
            }
        }
    }

    /**
     * set theme type
     *
     * @param {String} newType - theme type, light or dark
     */
    setType(newType) {
        this.type = newType
    }

    /**
     * Get the correct palette
     *
     * @returns a pallete
     */
    palette(backend) {
        if (backend.key === 'Voetmax') return this.voetmax()
        if (backend.key === 'Schutrups') return this.schutrups()
        return this.vcw()
    }

    /**
     * Get the correct palette
     *
     * @returns a pallete
     */
    theme(backend) {
        // special for koen
        // if (process.env.NODE_ENV !== 'production') {
        //     this.type = 'dark'
        // }
        const theme = createTheme({
            typography: {
                fontFamily: 'Roboto, Helvetica Neue, sans-serif'
            },
            components: {
                MuiCssBaseline: {
                    styleOverrides: `
                    @font-face {
                      font-family: 'Roboto';
                      src: url(${robotoRegular});
                    }
                    @font-face {
                      font-family: 'Roboto-Light';
                      src: url(${robotoLight});
                    }
                  `
                }
            },
            palette: this.palette(backend)
        })
        return theme
    }
}

export default new ThemeProvider()